import { useQuery } from "@tanstack/react-query";
import { getMonthlyForecastEcomm } from "../services/eccomForecastMonthlyService";

export const useMonthlyForecastEcomm = (month = "2025-04") => {
  return useQuery({
    queryKey: ["ecomm-monthlyForecast", month],
    queryFn: () => getMonthlyForecastEcomm(month),
    staleTime: 1000 * 60 * 5, 
  });
};